import { useLocation, Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const routeLabelMap: Record<string, string> = {
  '': '首页',
  'categories': '娱乐分类',
  'articles': '精品文章',
  'about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  pathSegments.forEach((segment, index) => {
    const href = '/' + pathSegments.slice(0, index + 1).join('/');
    const label = routeLabelMap[segment] || decodeURIComponent(segment);
    breadcrumbs.push({ label, href: index < pathSegments.length - 1 ? href : undefined });
  });

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100/70 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
          {breadcrumbs.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="mx-1 text-foreground-400" aria-hidden="true">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}